import { Component } from '@angular/core';

@Component({
  selector: 'app-scenario',
  standalone: false,
  templateUrl: './scenario.component.html',
  styleUrl: './scenario.component.scss'
})
export class ScenarioComponent {

}
